export default "__VITE_ASSET__DTghMaaO__"